import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  Select,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  DialogActions,
  Button,
  Grid,
  TextField,
  IconButton,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./style.css";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { addResourceSchema } from "./utils";
import { Container } from "@mui/system";
import axiosInstance from "../../../../axios";
import { useDispatch } from "react-redux";
import { fetchSessionResources } from "../../../../redux/slices/session-management.slice";
import { CoPresentOutlined } from "@mui/icons-material";

const AddResourcePopUp = ({
  sessionId,
  open,
  setAddResourceOpen,
  sessionResourcesPage,
  sessionResourcesLimit,
}) => {
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      sessionId: sessionId,
      resourceName: "",
      resourceType: "",
      resourceFile: "",
      resourceLink: "",
      dueDate: "",
      isPublish: false,
    },
    resolver: yupResolver(addResourceSchema),
    mode: "onChange",
  });

  const resourceType = watch("resourceType");
  const [isUploading, setIsUploading] = useState(false);

  const handleClose = () => {
    reset();
    setAddResourceOpen(false);
  };

  const dispatch = useDispatch();

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const data = getValues();

    const payload = {
      sessionId: data?.sessionId,
      resourceName: data?.resourceName,
      resourceType: data?.resourceType,
      resourceLink: data?.resourceLink,
      resourceFile: data?.resourceFile,
      isPublish: data?.isPublish,
      ...(resourceType === "ASSIGNMENT" && { dueDate: data?.dueDate }),
    };

    try {
      const response = await axiosInstance.post("/resources/add", payload);
      console.log(response.data);
      if (response?.data?.statusCode === 200) {
        toast.success(response?.data?.message);
        setAddResourceOpen(!open);
        reset();
        dispatch(
          fetchSessionResources({
            sessionId,
            sessionResourcesLimit,
            sessionResourcesPage,
          })
        );
      }
    } catch (e) {}
  };

  const handleUploadFile = async ({ target }) => {
    const files = target.files[0];
    let formData = new FormData();
    formData.append("file", files);
    formData.append("module", "batch");
    let payload = formData;

    setIsUploading(true);
    try {
      const { data } = await axiosInstance.post(`/upload`, payload);

      data.statusCode === 200 &&
        setValue("resourceFile", data?.payload?.fileURL);
      // error && handleError(error);
    } catch (e) {}
    setIsUploading(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className="add-resource-popup-container"
    >
      {isUploading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: 1 }}
          open={isUploading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <DialogTitle>
        <Typography variant="h6">Add Resource</Typography>
        <IconButton
          sx={{
            position: "absolute",
            right: 8,
            top: 10,
            color: "black",
          }}
          onClick={() => handleClose()}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={handleFormSubmit}>
        <DialogContent>
          <Grid
            container
            spacing={2}
            sx={{ marginTop: "0.5rem", marginBottom: "2rem" }}
          >
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                select
                fullWidth
                size="small"
                label="Resource Type"
                inputProps={register("resourceType")}
                {...register("resourceType", {
                  required: true,
                })}
                required
              >
                <MenuItem key={1} value="RECORDING">
                  Recording
                </MenuItem>
                <MenuItem key={2} value="STUDY MATERIAL">
                  Study Material
                </MenuItem>
                <MenuItem key={3} value="LINKS">
                  Links
                </MenuItem>
                <MenuItem key={4} value="ASSIGNMENT">
                  Assignment
                </MenuItem>
              </TextField>
              <small style={{ color: "red" }}>
                {errors?.resourceType?.message}
              </small>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                label="Resource Name"
                required
                size="small"
                fullWidth
                {...register("resourceName", {
                  required: true,
                })}
              />
              <small style={{ color: "red" }}>
                {errors?.resourceName?.message}
              </small>
            </Grid>
            <Grid item xs={2} sm={2} md={2}>
              <Typography>Resource File:</Typography>
            </Grid>
            <Grid item xs={10} sm={10} md={10}>
              <TextField
                size="small"
                type="file"
                disabled={resourceType === "" || resourceType === "LINKS"}
                helperText="Add Document or media"
                onChange={handleUploadFile}
                required
                fullWidth
              />
            </Grid>
            <Grid item xs={2} sm={2} md={2}>
              <Typography>Resource Link:</Typography>
            </Grid>
            <Grid item xs={10} sm={10} md={10}>
              <TextField
                size="small"
                label="Add Link"
                disabled={
                  resourceType === "" ||
                  resourceType === "ASSIGNMENT" ||
                  resourceType === "STUDY MATERIAL" ||
                  resourceType === "RECORDING"
                }
                required
                type="url"
                fullWidth
                {...register("resourceLink", {
                  required: true,
                })}
              />
              {/* <small style={{ color: "red" }}>
                {errors?.resourceLink && "Please fill this field"}
              </small> */}
            </Grid>
            {resourceType === "ASSIGNMENT" && (
              <Grid item xs={12} sm={12} md={12}>
                <TextField
                  fullWidth
                  type="date"
                  disabled={resourceType === ""}
                  helperText="Due Date"
                  size="small"
                  {...register("dueDate")}
                  InputProps={{
                    inputProps: { min: moment().format("YYYY-MM-DD") },
                  }}
                  required={resourceType === "ASSIGNMENT"}
                />
              </Grid>
            )}
          </Grid>
          <Container sx={{ textAlign: "end" }}>
            <Button onClick={handleClose}>Reset</Button>
            <Button
              type="submit"
              // onClick={() => handlePlanAdd(selectedPlan)}
              //  disabled={getValues().resourceName === "" || getValues().resourceType === "" || getValues().resourceLink === "" }
              variant="contained"
            >
              Add
            </Button>
          </Container>
        </DialogContent>
        {/* <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          //   onClick={() => handlePlanAdd(selectedPlan)}
          //   disabled={!!!selectedPlan}
          variant="contained"
        >
          Submit
        </Button>
      </DialogActions> */}
      </form>
    </Dialog>
  );
};

export default AddResourcePopUp;
